import styled from 'styled-components';

export const NoAdsMessageStyles = styled.div`
  padding: 90px 0px;
  text-align: center;

  & .text {
    display: inline-block;
    margin: 0 0 14px 12px;
  }
`;
